import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from '../shared/components/components.module';

import { LoadwordRoutingModule } from './loanword-routing.module';

import { LoanwordComponent } from './loanword.component';


@NgModule({
  declarations: [
    LoanwordComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    LoadwordRoutingModule,
  ]
})
export class LoanwordModule { }
